import ScreenWrapper from "@/components/ScreenWrapper"
import OrganizationDetailSidebar from "@/pages/organisaties/OrganizationDetailSidebar"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { LayoutWithSidebar } from "toptaal-shared"

export const Route = createFileRoute("/beheer/organisaties/$organizationId")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "organizations"),
})

function RouteComponent() {
  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar sidebar={<OrganizationDetailSidebar />}>
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
